import { render, staticRenderFns } from "./ClubLayout.vue?vue&type=template&id=dae57f78&"
import script from "./ClubLayout.vue?vue&type=script&lang=js&"
export * from "./ClubLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClubLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports